//React
import React from "react"
import { useTranslation } from "react-i18next"
import { Link, useLocation } from "react-router-dom"

//App
import { Routes } from "../../routes"



const HeaderInterview = () => {
    const location = useLocation()
    const searchParams = new URLSearchParams(location.search)
    const campaignId = searchParams.get('campaignId')
    const campaignName = searchParams.get('campaignName')
    const { t } = useTranslation()
    return (
        <div className="m-3  d-flex justify-content-between">
            { campaignId && campaignName ? (
                <Link to={Routes.CAMPAIGNS+"?id=" + campaignId+"&name=" + campaignName} className="text-light fw-bold fs-5 text-decoration-none m-none">
                    <div className="d-flex">
                        <span><i className="fa-solid fa-arrow-left"></i></span>
                        <p className="ms-1 text-uppercase">{campaignName}</p>
                    </div>
                </Link>
            ) : (
                <Link to={Routes.HOMEVIEW} className="text-light fw-bold fs-5 text-decoration-none m-none">
                    <div className="d-flex">
                        <span><i className="fa-solid fa-arrow-left"></i></span>
                        <p className="ms-1 text-uppercase">{t('words.home')}</p>
                    </div>
                </Link>
            )
            }

            <button className="web-none text-decoration-none bg-transparent" data-bs-toggle='offcanvas' data-bs-target='#offcanvas'>
                <i className="fa-solid fa-bars text-white"></i>
            </button>

        </div>
    )
}

export default HeaderInterview